// The four people counts on `places` spell "not reported" as -1: PocketBase
// number fields cannot be NULL, so unknown has to be a value. 0 is a real
// reported zero and must survive.
//
// Without this, an emptied box goes parseInt("") -> NaN -> null over JSON ->
// placeRecord.set(col, null), which PocketBase coerces to 0 on a NUMERIC
// column — silently turning "no answer" into "zero people".
export const COUNT_COLUMNS = [
  "total_people_count",
  "women_count",
  "men_count",
  "under18_count",
]

export const countValue = (raw) => {
  const n = parseInt(raw, 10)
  return Number.isNaN(n) ? -1 : n
}
